import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { NavbarComponent } from './navbar/navbar.component';
import { childTokenGuard } from './Guards/child-token.guard';
import { RefreshComponent } from './refresh/refresh.component';
import { ResetPasswordNewComponent } from './reset-password-new/reset-password-new.component';
/* import { DashboardComponent } from './task-management/dashboard/dashboard.component'; */
import { TasksComponent } from './task-management/tasks/tasks.component';
import { FilePreviewComponent } from './shared/file-preview/file-preview.component';
import { RecoverComponent } from './recover/recover.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AttendanceComponent } from './task-management/attendance/attendance.component';
import { RegularizationListComponent } from './task-management/regularization/regularization-list/regularization-list.component';
import { LeaveListComponent } from './task-management/leave/leave-list/leave-list.component';
import { RosterListComponent } from './task-management/roster/roster-list/roster-list.component';
import { RosterSchedulerComponent } from './task-management/roster/roster-scheduler/roster-scheduler.component';

const routes: Routes = [
	{ path: '', redirectTo: '/login', pathMatch: 'full' },
	{ path: 'refresh', component: RefreshComponent },
	{ path: 'login', component: LoginComponent },
	{ path: 'recover', component: RecoverComponent },
	{ path: 'setnewpassword/:user/:token', component: ResetPasswordComponent },
	{ path: 'forgot-password', component: ResetPasswordNewComponent },
	{
		path: 'app', component: NavbarComponent, data: { breadcrumb: 'TopNavBar' }, canActivate: [childTokenGuard], children: [
			{ path: 'masters', loadChildren: () => import('./masters/masters.module').then(m => m.MastersModule), data: { animation: 1 } },
			/* { path: 'dashboard', component: DashboardComponent, data: { animation: 2 } }, */
			{ path: 'dashboard', component: TasksComponent, data: { animation: 3 } },
			{ path: 'file-preview', component: FilePreviewComponent, data: { animation: 5 } },
			{ path: 'attendance', component: AttendanceComponent, data: { animation: 6 } },
			{ path: 'regularization', component: RegularizationListComponent, data: { animation: 7 } },
			{ path: 'leave', component: LeaveListComponent, data: { animation: 8 } },
			{ path: 'roster', component: RosterListComponent, data: { animation: 9 } },
			{ path: 'roster-scheduler', component: RosterSchedulerComponent, data: { animation: 10 } },
		]
	},
	{ path: '**', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
